import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconKeyhole2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKeyhole2"><Path d="M5.5 9C5.5 11.591 7.01596 13.8279 9.2093 14.8721L7 21.5H17L14.7907 14.8721C16.984 13.8279 18.5 11.591 18.5 9C18.5 5.41015 15.5899 2.5 12 2.5C8.41015 2.5 5.5 5.41015 5.5 9Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconKeyhole2;
